import React, { useEffect, useState } from 'react'
import moment from 'moment'
import MobileSearchHeader from '../../components/mobile/mobileSearchHeader'
import MobileCard from '../../components/mobile/mobileCard'
import ShiftListItem from '../../components/mobile/shiftListItem'
import MobileShiftsFilter, { defaultShiftsFilters } from '../../components/mobile/mobileShiftsFilter'
import { workShiftService } from '../../functions/services/workshift.service'

const defaultTake = 30

const mapShift = shift => ({
   id: shift.workShiftId,
   startDate: shift.startTime ? moment(shift.startTime).format('DD.MM.YY') : '',
   startTime: shift.startTime ? moment(shift.startTime).format('HH:mm') : '',
   endDate: shift.endTime ? moment(shift.endTime).format('DD.MM.YY') : '',
   endTime: shift.endTime ? moment(shift.endTime).format('HH:mm') : '',
   revenue: Math.round((shift.totalRevenue || 0) / 100),
   tripCount: shift.numberOfTrips,
   rejectedCount: shift.numberOfDeclinedTrips,
   shiftNumber: shift.workShiftNumber
})

// Counts how many of the filter fields differ from their empty/default
// value, used to show a badge on the Filter button.
const countActiveShiftsFilters = filters => Object.values(filters).reduce((count, value) => (value ? count + 1 : count), 0)

const MobileShifts = () => {
   const [search, setSearch] = useState('')
   const [filters, setFilters] = useState(defaultShiftsFilters)
   const [filterOpen, setFilterOpen] = useState(false)
   const [shifts, setShifts] = useState([])
   const [loading, setLoading] = useState(true)
   const [expandedId, setExpandedId] = useState(null)

   useEffect(() => {
      // The workShift search endpoint doesn't have a free-text field; the search
      // box is wired to the shift number, which is the closest match.
      const searchModel = {
         from: filters.from || null,
         to: filters.to || null,
         permitNumber: filters.permitNumber || null,
         driverNumber: filters.driverNumber || null,
         regionName: null,
         shiftNumber: search || null,
         orderField: 'startTime',
         ascending: false,
         index: 0,
         take: defaultTake,
         utcOffset: moment().utcOffset()
      }

      setLoading(true)
      const timeoutId = setTimeout(() => {
         workShiftService.search(searchModel).then(
            response => {
               setShifts((response || []).map(mapShift))
               setLoading(false)
            },
            error => {
               console.error('Error fetching shifts:', error)
               setLoading(false)
            }
         )
      }, 300)

      return () => clearTimeout(timeoutId)
   }, [search, filters])

   return (
      <div>
         <MobileSearchHeader
            searchValue={search}
            onSearchChange={setSearch}
            onFilterClick={() => setFilterOpen(true)}
            activeFilterCount={countActiveShiftsFilters(filters)}
         />

         <MobileShiftsFilter
            open={filterOpen}
            onClose={() => setFilterOpen(false)}
            values={filters}
            onApply={setFilters}
         />

         <div className="p-4 pt-2 md:p-6 md:pt-2">
            <MobileCard noPadding>
               {loading ? (
                  <div className="p-4 text-center text-gray-500 md:text-lg">Laster...</div>
               ) : shifts.length === 0 ? (
                  <div className="p-4 text-center text-gray-500 md:text-lg">Ingen skift funnet</div>
               ) : (
                  shifts.map(shift => (
                     <ShiftListItem
                        key={shift.id}
                        shift={shift}
                        expanded={expandedId === shift.id}
                        onToggle={() => setExpandedId(expandedId === shift.id ? null : shift.id)}
                     />
                  ))
               )}
            </MobileCard>
         </div>
      </div>
   )
}

export default MobileShifts
